import clsx from 'clsx';
import React, { useCallback, useMemo, useState } from 'react';
import { CompaniesBlock, Modal } from '../_shared';
import { Sphere } from '../_shared';
import { CheckIcon } from '../Icons';
import { CheckSVG } from './assets/svg';
import { DashedLineGreen } from './assets/svg';
import { DashedLineViolet } from './assets/svg';
import styles from './Members.module.scss';
import { membersDummy } from '../_dummyData';
import Link from 'next/link';
import { rootLinks } from '../Links';
import { Props } from './Members.type';
import { Form, Formik } from 'formik';
import { Button } from '../../base-components/Button';
import { FormTextInput } from '../../base-components/FormTextInput';
import { validationSchema } from './lib/validationSchema';
import useModalState from '../_hooks/useModalState';
import { registrationHelpApi } from './lib/registrationHelpApi';

export const Members: React.FC<Props> = ({ orgSections }) => {
    const [isSuccessModalVisible, showSuccessModal, hideSuccessModal] =
        useModalState();
    const [successState, setSuccessState] = useState({
        header: 'Ошибка!',
        message: 'Что-то пошло не так. Пожалуйста, попробуйте еще раз',
    });

    const handleFormSubmit = useCallback(
        async (data, { resetForm }) => {
            try {
                await registrationHelpApi(data);

                setSuccessState({
                    header: 'Спасибо!',
                    message: 'Скоро мы с Вами свяжемся.',
                });
                resetForm();
            } finally {
                showSuccessModal();
            }
        },
        [showSuccessModal]
    );
    const initialValues = useMemo(() => {
        return {
            name: 'NO-NAME',
            contact: '',
            message: 'Нужна помощь с регистрацией',
        };
    }, []);

    return (
        <div className={styles.container}>
            <Sphere
                zIndex={1}
                color="violet"
                step={0.009}
                maxMove={20}
                opacity={0.7}
            />
            <Sphere zIndex={2} color="orange" step={0.01} maxMove={30} />
            <div className={styles.content}>
                <h1 className={styles.title}>Поставщикам</h1>
                <div className={styles.bonuses}>
                    {membersDummy.bonuses.map((bonus, key) => (
                        <div key={key} className={styles.bonus}>
                            <CheckIcon className={styles.icon} />
                            <div className={styles.bonusText}>{bonus}</div>
                        </div>
                    ))}
                </div>
                <div className={styles.roadmap}>
                    <div className={styles.steppes}>
                        <div
                            className={clsx(
                                styles.step,
                                styles.first,
                                styles.blue
                            )}
                        >
                            <div className={styles.circle}>1</div>
                        </div>
                        <DashedLineViolet
                            className={clsx(styles.dotLine, styles.first)}
                        />
                        <div
                            className={clsx(
                                styles.step,
                                styles.second,
                                styles.blue
                            )}
                        >
                            <div className={styles.circle}>2</div>
                        </div>
                        <DashedLineGreen
                            className={clsx(styles.dotLine, styles.second)}
                        />
                        <div
                            className={clsx(
                                styles.step,
                                styles.third,
                                styles.green
                            )}
                        >
                            <div className={styles.circle}>3</div>
                        </div>
                        <div className={clsx(styles.stepText, styles.first)}>
                            Регистрация
                        </div>
                        <div className={clsx(styles.stepText, styles.second)}>
                            Аккредитация с электронной подписью
                        </div>
                        <div className={clsx(styles.stepText, styles.third)}>
                            Доступ <br /> к личному кабинету
                        </div>
                        <CheckSVG className={styles.check} />
                    </div>
                    <div className={styles.finish}>За один рабочий день</div>
                </div>
                <div />
                <div className={styles.promo}>
                    <div className={styles.promoTitle}>
                        Будем рады видеть Вас в числе участников на нашей
                        площадке!
                    </div>
                    <div className={styles.promoText}>
                        Начните строить долгосрочные взаимовыгодные связи с
                        заказчиками по всей России. Регистрация и аккредитация
                        бесплатно.
                    </div>
                    <Link href={rootLinks.auth.url}>
                        <a className={styles.promoButton}>
                            Начните работать прямо сейчас!
                        </a>
                    </Link>
                </div>
                <CompaniesBlock
                    orgSections={orgSections}
                    title="Наши заказчики"
                    isMembersPage={true}
                />
                <div className={styles.help}>
                    <div className={styles.helpTitle}>
                        Нужна помощь с регистрацией?
                    </div>
                    <div className={styles.helpText}>
                        Оставьте Вашу почту/номер телефона и мы свяжемся с вами
                        в течение часа
                    </div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                    >
                        {(formik) => (
                            <Form className={styles.helpForm}>
                                <FormTextInput
                                    name="contact"
                                    appearance="compact"
                                    label="Введите Ваш e-mail или номер телефона"
                                    className={styles.helpInput}
                                />
                                <Button
                                    variant="blue"
                                    disabled={formik.isSubmitting}
                                    type="submit"
                                    className={styles.helpSubmit}
                                >
                                    Отправить
                                </Button>
                            </Form>
                        )}
                    </Formik>
                    {isSuccessModalVisible && (
                        <Modal
                            onHide={hideSuccessModal}
                            header={successState.header}
                            className={styles.responseModal}
                        >
                            <p>{successState.message}</p>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
};
